import React from 'react';

const SistemPeringatanDiniBencana: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Indonesia berada di kawasan cincin api Pasifik (<i>Ring of Fire</i>) dan memiliki topografi perbukitan dengan curah hujan tropis yang tinggi. Kondisi ini menuntut tersedianya <b>Sistem Peringatan Dini Bencana (Early Warning System / EWS)</b> yang cepat, andal, dan dapat diakses oleh masyarakat di daerah rawan bencana longsor dan banjir bandang.
      </p>

      <p className="mb-4">
        Dalam kategori <b>Innovative Technology Challenge</b>, peserta mengembangkan stasiun EWS mandiri berbasis mikrokontroler Arduino yang dilengkapi sensor kemiringan tanah (<i>Inclinometer/MPU6050</i>), sensor getaran piezoelektrik, dan sensor curah hujan (<i>Tipping Bucket Rain Gauge</i>).
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Tingkat Status Peringatan Otomatis
      </h2>
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <div className="border border-green-200 rounded-lg p-3 bg-green-50">
          <h3 className="font-semibold text-green-700 mb-1">🟢 Status Waspada</h3>
          <p className="text-sm text-gray-700">Curah hujan di atas 50 mm/jam terdeteksi; sistem mulai mengaktifkan transmisi data frekuensi tinggi.</p>
        </div>
        <div className="border border-yellow-200 rounded-lg p-3 bg-yellow-50">
          <h3 className="font-semibold text-yellow-700 mb-1">🟡 Status Siaga</h3>
          <p className="text-sm text-gray-700">Pergeseran kemiringan tanah &gt; 2 derajat terdeteksi; notifikasi peringatan otomatis terkirim ke ponsel posko desa.</p>
        </div>
        <div className="border border-red-200 rounded-lg p-3 bg-red-50">
          <h3 className="font-semibold text-red-700 mb-1">🔴 Status Awas</h3>
          <p className="text-sm text-gray-700">Pergeseran mendadak &gt; 5 derajat; sirene alarm darurat berbunyi nyaring untuk evakuasi warga lereng bukit.</p>
        </div>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Jaringan Komunikasi Darurat Redundan
      </h2>
      <p className="mb-4">
        Untuk mengantisipasi putusnya jaringan internet seluler saat cuaca ekstrem, perangkat EWS ini menggunakan komunikasi radio frekuensi mandiri (LoRa) yang mampu memancarkan sinyal darurat hingga radius 5 kilometer menembus kontur perbukitan.
      </p>

      <p className="mb-4">
        Pengembangan teknologi mitigasi bencana karya siswa ini menegaskan bahwa sains dan rekayasa terapan memiliki misi mulia untuk menyelamatkan jiwa manusia dari ancaman bencana alam.
      </p>
    </div>
  );
};

export default SistemPeringatanDiniBencana;
